const videoElements = document.querySelectorAll('.js-video--container');

videoElements.forEach(function(videoElement){
    var playButton = videoElement.querySelector(".js-video--play");
    var video = videoElement.querySelector(".js-video--element");

    playButton.addEventListener("click", function() {
        if (video.paused == true) {
            pauseAllVideos();
            video.play();
            playButton.innerHTML = "Pause";
            playButton.classList.add('isPlaying');
        } else {
            video.pause();
            playButton.innerHTML = "Play";
            playButton.classList.remove('isPlaying');
        }
    });
});

function pauseAllVideos () {
    videoElements.forEach(function(videoElement){
        var playButton = videoElement.querySelector(".js-video--play");
        var video = videoElement.querySelector(".js-video--element");

        video.pause();
        playButton.innerHTML = "Play";
        playButton.classList.remove('isPlaying');
    });
}